export default __webpack_public_path__ + "static/media/bg_white.1e669b5e.png";